"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_document_thunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const main_1 = require("../../../main");
const document_1 = require("../../document");
const get_document_1 = require("../../../../../api/calls/document/get_document");
exports.get_document_thunk = (0, toolkit_1.createAsyncThunk)("documents/thunks/get_document_thunk", (arg, { dispatch, getState }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { data } = arg;
    dispatch((0, document_1.setIsLoading)(true));
    const response = yield (0, get_document_1.get_document)(data);
    dispatch((0, document_1.setIsLoading)(false));
    if (response.success) {
        dispatch((0, document_1.setSelectedDocument)(Object.assign({}, (_a = response.content) === null || _a === void 0 ? void 0 : _a.document)));
        dispatch((0, document_1.setSelectedDocumentElements)([]));
    }
    else {
        // Check if FaceTec authentication is required
        if (response.requiresFaceTec) {
            dispatch((0, main_1.setMessageModal)({
                title: "Authentication Required",
                messages: [response.message || "Please complete Facial Recognition to view this document."],
            }));
            // Could redirect to FaceTec page here if needed
            // window.location.href = `/console/facetec?document_id=${data._id}`;
        }
        else {
            dispatch((0, main_1.setMessageModal)({
                title: "Something went wrong!",
                messages: [response.message || "Unable to load document."],
            }));
        }
    }
}));
